import { render } from "./forooshgah.vue?vue&type=template&id=84992cd6"
import script from "./forooshgah.vue?vue&type=script&lang=js"
export * from "./forooshgah.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/omidnoorani-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__